/// <reference lib="webworker" />

export enum PostMessageType {
  INIT = 'INIT'
}

export interface PostMessageInputData<T = never> {
  type?: T | PostMessageType;
}

export interface PostMessageInput<T = PostMessageInputData> extends ExtendableMessageEvent {
  data: T;
}

export interface PostMessageOutputData {
  ready?: boolean;
}
